import type { TCreateSlice } from "@/store";

import type { TAnnualizationType } from "@/apis/odin/apiODIN";

export const getInterval = (group: "month" | "quarter" | "half" | "year") => {
    if (group === "month") return 1;
    if (group === "quarter") return 3;
    if (group === "half") return 6;
    if (group === "year") return 12;
    return 1;
};

type TStateAnnualizedExtraction = {
    extractionAnnaualizedStartDate: string | null;
    extractionAnnaualizedEndDate: string | null;
    selectedAnnualizationGroup: "month" | "quarter" | "half" | "year";
    showAnnualizationSource: boolean;
    showReconciliation: boolean;
    annualizationType: TAnnualizationType;
};

type TActionsPublicAnnualizedExtraction = {
    resetAnnualizedExtractionState: () => void;
    setSelectedAnnualizationGroup: (
        group: "month" | "quarter" | "half" | "year",
    ) => void;
    setExtractionAnnualizedDateRange: (params: {
        startDate: string;
        endDate: string;
    }) => void;
    setShowAnnualizationSource: (showSource: boolean) => void;
    setAnnualizationType: (type: TAnnualizationType) => void;
    setShowReconciliation: (show: boolean) => void;
};

export type TSliceAnnualizedExtraction = TStateAnnualizedExtraction &
    TActionsPublicAnnualizedExtraction;

const initialStateAnnualizedExtraction: TStateAnnualizedExtraction = {
    extractionAnnaualizedStartDate: null,
    extractionAnnaualizedEndDate: null,
    selectedAnnualizationGroup: "month",
    showAnnualizationSource: false,
    showReconciliation: false,
    annualizationType: "monthly_actual",
};

export const createSliceAnnualizedExtraction: TCreateSlice<
    TSliceAnnualizedExtraction
> = () => set => {
    const actionsPublic: TActionsPublicAnnualizedExtraction = {
        resetAnnualizedExtractionState: () => {
            set(
                initialStateAnnualizedExtraction,
                false,
                "annualizedExtraction/resetAnnualizedExtractionState",
            );
        },
        setShowReconciliation: showReconciliation => {
            set(
                { showReconciliation },
                false,
                "annualizedExtraction/setShowReconciliation",
            );
        },
        setAnnualizationType: (type: TAnnualizationType) => {
            set(
                {
                    annualizationType: type,
                },
                false,
                "annualizedExtraction/setAnnualizationType",
            );
        },
        setShowAnnualizationSource: (showSource: boolean) => {
            set(
                {
                    showAnnualizationSource: showSource,
                },
                false,
                "annualizedExtraction/setShowAnnualizationSource",
            );
        },
        setSelectedAnnualizationGroup: (
            group: "month" | "quarter" | "half" | "year",
        ) => {
            set(
                {
                    selectedAnnualizationGroup: group,
                },
                false,
                "annualizedExtraction/setSelectedAnnualizationGroup",
            );
        },
        setExtractionAnnualizedDateRange: ({ startDate, endDate }) => {
            set(
                {
                    extractionAnnaualizedStartDate: startDate,
                    extractionAnnaualizedEndDate: endDate,
                },
                false,
                "annualizedExtraction/setDateRange",
            );
        },
    };

    return {
        ...initialStateAnnualizedExtraction,
        ...actionsPublic,
    };
};
